var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-list"},_vm._l((_vm.tags),function(tag,key){return _c('Tag',{key:key,attrs:{"text":tag.label || tag,"type":_vm.type,"is-ellipsis":_vm.isEllipsis,"to":tag.to}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }